<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!haveItems">Você não possui sorteios ativos</h3>
            <h3 v-if="haveItems">Você possui {{ numSorteios }} sorteios ativos</h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              v-b-modal.modalAddSorteio
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar sorteio
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="text-center f-g" v-if="!haveItems">
      <i class="fa fa-frown-o fa-custom-size"></i>
      <h4>Desculpe, não encontramos nenhum sorteio :(</h4>
      <h5>Para iniciar, clique no botão acima e comece as integrações!</h5>
    </b-card>
    <b-card class="text-center mt-3" v-if="haveItems">
      <b-table :items="items" :fields="fields" striped bordered hover @row-clicked="rowHandler">
        <template v-slot:cell(urlthumbnail)="data">
          <img
            v-if="data.item.urlthumbnail"
            :src="data.item.urlthumbnail"
            alt="Thumbnail"
            style="height: 32px;"
          />
          <span v-else>Sem imagem</span>
        </template>
        <template v-slot:cell(isdestaque)="data">
          <i v-if="data.item.isdestaque == 1" class="fa fa-star fa-lg"></i>
          <i v-else class="fa fa-star-o fa-lg"></i>
        </template>
      </b-table>
    </b-card>
    <b-modal id="modalAddSorteio" centered title="Adicionar sorteio">
      <span
        class="mx-auto text-center"
      >Para adicionar uma sorteio, escolha uma das opções abaixo para continuar:</span>
      <div slot="modal-footer" class="w-100">
        <b-row>
          <b-col cols="12">
            <b-button
              class="m-w mb-10"
              variant="danger"
              @click="inserirSorteio"
            >Vincular com o sistema Accesys</b-button>
          </b-col>
          <b-col cols="12">
            <b-button class="m-w" disabled>Criar manualmente</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal ref="modalEditaSorteio" size="lg" centered hide-footer :title="titleSorteioModal">
      <b-row>
        <b-col cols="6" @click="destacarSorteio(idSorteioSelecionado)">
          <b-col cols="12" class="centerModal">
            <i v-if="sorteioDestacado" class="fa fa-star-o fa-custom-size" aria-hidden="true"></i>
            <i v-if="!sorteioDestacado" class="fa fa-star fa-custom-size" aria-hidden="true"></i>
            <span v-if="sorteioDestacado">
              Remover
              <br />destaque
            </span>
            <span v-if="!sorteioDestacado">
              Destacar
              <br />sorteio
            </span>
          </b-col>
        </b-col>
        <b-col cols="6" @click="editarImagem(urlImagemSelecionado)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-file-image-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="!urlImagemSelecionado">
              Vincular
              <br />Imagem
            </span>
            <span v-if="urlImagemSelecionado">
              Editar
              <br />Imagem
            </span>
          </b-col>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6" @click="editarSorteio(idSorteioSelecionado)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-edit fa-custom-size" aria-hidden="true"></i>
            <span>
              Editar
              <br />sorteio
            </span>
          </b-col>
        </b-col>
        <b-col cols="6" @click="desvincularSorteio(idSorteioSelecionado)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-times fa-custom-size" aria-hidden="true"></i>
            <span>
              Desvincular
              <br />sorteio
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "sorteios",
  components: {
    Loading
  },
  data: function() {
    return {
      isLoading: false,
      temSorteios: false,
      numSorteios: 0,
      items: [],
      fields: [
        { key: "urlthumbnail", label: "Imagem" },
        { key: "isdestaque", label: "Destaque" },
        { key: "titulo", label: "Sorteio" },
        { key: "descricao", label: "Descrição" },
        { key: "data_inicial", label: "Início" },
        { key: "data_final", label: "Fim" }
      ],
      haveItems: false,
      titleSorteioModal: "",
      idSorteioSelecionado: "",
      urlImagemSelecionado: "",
      sorteioDestacado: false
    };
  },
  methods: {
    inserirSorteio() {
      this.$router.push("sorteios/inserir-sorteio");
    },
    limpaLocalStorage() {
      localStorage.removeItem("image");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
      localStorage.removeItem("have-push");
      localStorage.removeItem("titulo_sorteio");
      localStorage.removeItem("id_sorteio");
      localStorage.removeItem("url_imagem");
    },
    atualizarJornalzinho() {
      this.$router.push("sorteios/atualizar-jornalzinho");
    },
    rowHandler(record, index) {
      this.titleSorteioModal = `Sorteio: ${record.titulo}`;
      this.idSorteioSelecionado = record.id;
      this.urlImagemSelecionado = record.urlimagem;
      if (record.isdestaque == 1) {
        this.sorteioDestacado = true;
      } else {
        this.sorteioDestacado = false;
      }
      this.$refs.modalEditaSorteio.show();
    },
    editarImagem(url) {
      localStorage.setItem("url_imagem", url);
      localStorage.setItem("titulo_sorteio", this.titleSorteioModal);
      localStorage.setItem("id_sorteio", this.idSorteioSelecionado);
      this.$router.push({ path: "sorteios/editar-imagem" });
    },
    editarSorteio() {
      this.$router.push({
        path: `sorteios/editar-sorteio/${this.idSorteioSelecionado}`
      });
    },
    desvincularSorteio(id) {
      this.$refs.modalEditaSorteio.hide();
      const options = {
        title: "Desvincular sorteio",
        cancelLabel: "Cancelar",
        okLabel: "Sim"
      };
      this.$dialogs
        .confirm("Confirma desvincular este sorteio do app?", options)
        .then(res => {
          console.log(res);
          if (res.ok == true) {
            axios
              .delete(
                `${config.default.servidor}/gerencial/sorteio/${id}`,
                {
                  headers: {
                    Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                  }
                }
              )
              .then(response => {
                if (response.status == 200) {
                  const options = { title: "Aviso", size: "sm" };
                  this.$dialogs
                    .alert("O sorteio foi desvinculado com sucesso.", options)
                    .then(res => {
                      console.log(res);
                    });
                  this.procurarSorteios();
                }
              });
          }
        });
    },
    procurarSorteios() {
      this.isLoading = true;
      axios
        .get(
          `${
            config.default.servidor
          }/gerencial/sorteio/ativo/${localStorage
            .getItem("enterprise_id")
            .toString()}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.data.data.length != 0) {
            console.log(response.data.data);
            this.items = response.data.data;
            this.numSorteios = this.items.length;
            this.haveItems = true;
          } else {
            this.haveItems = false;
          }
          this.isLoading = false;
        });
    },
    destacarSorteio(id) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].id == id) {
          if (
            this.items[i].urlimagem != undefined ||
            this.items[i].urlimagem != null ||
            this.items[i].urlimagem != ""
          ) {
            axios
              .post(
                `${config.default.servidor}/gerencial/sorteio/destaque`,
                {
                  id: id,
                  destaque: this.items[i].isdestaque
                },
                {
                  headers: {
                    Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                  }
                }
              )
              .then(response => {
                if (response.status == 200) {
                  let toast = this.$toasted.show("Sucesso!", {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 5000,
                    icon: "check",
                    iconPack: "fontawesome"
                  });
                  this.procurarSorteios();
                  this.$refs.modalEditaSorteio.hide();
                }
              });
          } else {
            let toast = this.$toasted.show("Erro.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          }
        }
      }
    }
  },
  beforeMount() {
    this.limpaLocalStorage();
    this.procurarSorteios();
  }
};
</script>
